// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__W2YnF","title":"ClientInsurance_title___EDdG","itemText":"ClientInsurance_itemText__2Izul"};